import * as React from 'react';
import './GroupPDF.css';
import { AppStore } from '../../../../stores';
import { inject, observer } from 'mobx-react';
import GroupService from '../../../../services/GroupService';
import { IGroupMemberInfo } from '../../../../interfaces/IGroupMemberInfo';
import { Accordion } from '../../../accordion/Accordion';
import IconService from '../../../../services/IconService';
import * as d3 from "d3";
import Moment from 'react-moment';

import { useMemo, useRef } from 'react';
import GroupResultBar from '../groupDetails/groupResultBar/GroupResultBar';

export interface IProps {
  appStore?: AppStore;
}

export interface IState {
  typesAndScores: { type: number, score: number }[];
  typesAndScoresFullResult: { type: number, score: number }[];
  members?: IGroupMemberInfo[];
  loadingContent: number;
  displayType: "bar" | "donut";
  id?: string;
}


@inject('appStore')
@observer
export default class GroupPDF extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    const urlParams = new URLSearchParams(window.location.search);
    let groupId;
    if (urlParams.get('id') != undefined) {
      groupId = urlParams.get('id');
    }
    this.state = {
      id: groupId,
      loadingContent: 0,
      typesAndScores: [
        { type: 1, score: 0 },
        { type: 2, score: 0 },
        { type: 3, score: 0 },
        { type: 4, score: 0 },
        { type: 5, score: 0 },
        { type: 6, score: 0 },
        { type: 7, score: 0 },
        { type: 8, score: 0 },
        { type: 9, score: 0 },
      ],
      typesAndScoresFullResult: [
        { type: 1, score: 0 },
        { type: 2, score: 0 },
        { type: 3, score: 0 },
        { type: 4, score: 0 },
        { type: 5, score: 0 },
        { type: 6, score: 0 },
        { type: 7, score: 0 },
        { type: 8, score: 0 },
        { type: 9, score: 0 },
      ],
      displayType: "donut"
    }
  }

  public componentDidMount(): void {
    const typesAndScores = this.state.typesAndScores;
    const typesAndScoresFullResult = this.state.typesAndScoresFullResult;
    GroupService.getGroup(this.state.id).then((group) => {
      this.props.appStore!.groupToView = group;
      this.setState({ loadingContent: this.state.loadingContent + 1 });
    });
    GroupService.getGroupMemberInfoForGroup(this.state.id).then((groupMembersInfo: IGroupMemberInfo[]) => {
      console.log(groupMembersInfo);
      const members = [];
      groupMembersInfo.forEach((groupMemberInfo: IGroupMemberInfo) => {
        if (typesAndScores[groupMemberInfo.type - 1]) {
          members.push(groupMemberInfo);
          typesAndScores[groupMemberInfo.type - 1].score++;
        }
        console.log(groupMemberInfo.result);
        groupMemberInfo?.result?.forEach((result, index) => {
          typesAndScoresFullResult[index].score += result.points;
        });
      });
      this.setState({ typesAndScores, typesAndScoresFullResult, members, loadingContent: this.state.loadingContent + 1 });
    });
  }

  private getColorForType = (type: number): string => {
    switch (type) {
      case 1:
        return "#eca140"; // darker soft green
      case 2:
        return "#b9d253"; // darker gentle blue
      case 3:
        return "#748243"; // darker light pink
      case 4:
        return "#4da964"; // darker warm beige
      case 5:
        return "#22548c"; // darker muted lavender
      case 6:
        return "#685d97"; // darker pale teal
      case 7:
        return "#7199cd"; // darker creamy yellow
      case 8:
        return "#d04c39"; // darker soft purple
      case 9:
        return "#9c4632"; // darker minty aqua
      default:
        return "#ffffff";
    }
  }

  private showResult(displayType: "bar" | "donut"): JSX.Element {
    const allPoints = this.state.typesAndScoresFullResult.map(item => item.score).reduce((prev, curr) => prev + curr, 0);
    const sorted = JSON.parse(JSON.stringify(this.state.typesAndScoresFullResult)).sort((a, b) => b.score - a.score);
    const winningType = sorted[0].score;
    if (displayType === "bar") {
      return (
        <div style={{
          marginLeft: 30,
          marginTop: 10,
          float: "left",
        }}>
          {this.state.typesAndScoresFullResult.map((typeAndScore, index) => {
            return (
              <GroupResultBar
                key={`resultBar_${typeAndScore.type}`}
                type={typeAndScore.type}
                points={typeAndScore.score}
                scoreForWinner={winningType}
                totalParticipants={allPoints}
                winner={index === 0}
                backgroundColor={"#f0f0f0"}
                barColor={"#bebebeff"}
                textColor={"#333333"}
                iconBackgroundColor={this.getColorForType(typeAndScore.type)}
                iconTextColor={"#ffffff"}
                onlyShowProcentage
                onClick={() => {
                }}
              />
            );
          })}
        </div>
      )
    } else {
      const data = [];
      this.state.typesAndScores.sort((a, b) => b.type - a.type).map((typeAndScore) => {
        data.push(
          {
            name: typeAndScore.type,
            value: Math.floor(typeAndScore.score / this.state.members.length * 100),
          }
        );
      })
      return (
        <div style={{
          height: 530,
          position: "relative",
          width: "100%",
          marginTop: 20,
        }}>
          {data.filter(item => item.value > 0).length === 0 ? (
            <PieChart data={data.map(item => ({ ...item, value: 1 }))} width={720} height={500} example />
          ) : (
            <PieChart data={data} width={720} height={500} />
          )}
        </div>
      )
    }
  }

  // const [response, setResponse] = useState("");

  // const sendPrompt = async () => {
  //   const res = await fetch("https://api.openai.com/v1/chat/completions", {
  //     method: "POST",
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': 'Bearer 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'
  //     },
  //     body: JSON.stringify({
  //       model: "gpt-3.5-turbo",
  //       messages: [{ role: "user", content: prompt }]
  //     })
  //   });
  //   const data = await res.json();
  //   setResponse(data.choices?.[0]?.message?.content || "No response");
  // };

  render() {
    return (
      <div className='pdfWrapper'>
        <div className="pdfWrapperHeader">
          <button
            onClick={() => {
              window.print();
            }}
          >
            Download PDF
          </button>
        </div>
        <div
          className="pdf"
          id="printarea"
          style={{
            right: this.props.appStore!.groupToView != undefined ? 0 : -screen.width,
          }}
        >
          {this.state.loadingContent < 2 ?
            <>Loading...</>
            :
            <>
              {this.state.members &&
                <>
                  <div className="page">
                    <div className='pdfHeader'><div style={{ float: "left" }}>MINDJUICE TEAMTEST</div><div style={{ color: "#aeaeae", float: "right" }}>Alle rettigheder tilhører Mindjuice © 2025</div></div>
                    <h1>{this.props.appStore!.groupToView?.name}</h1>
                    <p>{this.props.appStore!.groupToView?.description?.replace("{user}", this.props.appStore!.user?.name || "")}</p>
                    <Accordion
                      isMobile={this.props.appStore!.isMobile || this.props.appStore!.isIpad}
                      items={[
                        {
                          title: `${this.props.appStore!.groupToView?.invites?.length ?? 0} inviterede`,
                          icon: IconService.getIcon("Invite", "#333333"),
                        }, {
                          title: `${this.state.members?.length ?? 0} ${this.state.members?.length > 1 ? window.loc.strings.participants : window.loc.strings.participant}`,
                          icon: IconService.getIcon("Participants", "#333333"),
                        }, {
                          title: <Moment format="DD/MM YYYY" local>{this.props.appStore!.groupToView?.createdAt}</Moment>,
                          icon: IconService.getIcon("Created", "#333333"),
                        },
                      ]}
                      openInPopup={(url: string) => { }}
                      openInPageEmbed={(url: string) => { }}
                      backgroundColor={"#ffffff"}
                      borderColor={"#dbdbdb"}
                      style={{
                        marginTop: 20,
                      }}
                      itemStyle={{
                        borderRadius: 10,
                      }}
                    />
                    <h2>Fordeling af gruppens typer</h2>
                    {this.showResult("donut")}

                  </div>
                  <div className="page">
                    <h2>Vægtning af typerne ud fra det fulde testresultat</h2>
                    {this.showResult("bar")}
                    {/* <div style={{ marginTop: 20, float: "left", width: "100%", paddingBottom: 50 }}>
                      <h2>Hvad betyder resultatet?</h2>
                      <p>Kommer snart...</p>
                    </div> */}
                  </div>
                </>
              }
            </>
          }
        </div>
      </div>
    );
  }
}

type DataItem = {
  name: string;
  value: number;
};


type PieChartProps = {
  width: number;
  height: number;
  data: DataItem[];
  example?: boolean;
};


const MARGIN_X = 150;
const MARGIN_Y = 50;
const INFLEXION_PADDING = 20; // space between donut and label inflexion point

export const PieChart = ({ width, height, data, example }: PieChartProps) => {


  const getColorForType = (type: number): string => {
    switch (type) {
      case 1:
        return "#eca140"; // darker soft green
      case 2:
        return "#b9d253"; // darker gentle blue
      case 3:
        return "#748243"; // darker light pink
      case 4:
        return "#4da964"; // darker warm beige
      case 5:
        return "#22548c"; // darker muted lavender
      case 6:
        return "#685d97"; // darker pale teal
      case 7:
        return "#7199cd"; // darker creamy yellow
      case 8:
        return "#d04c39"; // darker soft purple
      case 9:
        return "#9c4632"; // darker minty aqua
      default:
        return "#ffffff";
    }
  }
  const ref = useRef(null);

  const radius = Math.min(width - 2 * MARGIN_X, height - 2 * MARGIN_Y) / 2;
  const sortedData = data.sort((a, b) => Number(b.name) - Number(a.name)).reverse();
  const pie = useMemo(() => {
    const pieGenerator = d3.pie<any, DataItem>().value((d) => d.value);
    return pieGenerator(sortedData);
  }, [sortedData]);

  const arcGenerator = d3.arc();

  const shapes = pie.filter((d) => d.value > 0).map((grp, i) => {
    // First arc is for the Pie
    const sliceInfo = {
      innerRadius: 0,
      outerRadius: radius,
      startAngle: grp.startAngle,
      endAngle: grp.endAngle,
    };
    const centroid = arcGenerator.centroid(sliceInfo);
    const slicePath = arcGenerator(sliceInfo);

    // Second arc is for the legend inflexion point
    const inflexionInfo = {
      innerRadius: radius + INFLEXION_PADDING,
      outerRadius: radius + INFLEXION_PADDING,
      startAngle: grp.startAngle,
      endAngle: grp.endAngle,
    };
    const inflexionPoint = arcGenerator.centroid(inflexionInfo);

    const isRightLabel = inflexionPoint[0] > 0;
    const labelPosX = inflexionPoint[0] + 50 * (isRightLabel ? 1 : -1);
    const textAnchor = isRightLabel ? "start" : "end";
    const label = example ? "Type " + grp.data.name : "Type " + grp.data.name + " (" + grp.value + "%)";

    return (
      <g
        key={i}
        className={"slice"}
        onMouseEnter={() => {
          if (ref.current) {
            ref.current.classList.add("hasHighlight");
          }
        }}
        onMouseLeave={() => {
          if (ref.current) {
            ref.current.classList.remove("hasHighlight");
          }
        }}
      >
        <path d={slicePath} fill={getColorForType(grp.data.name)} />
        <circle cx={centroid[0]} cy={centroid[1]} r={2} />
        <line
          x1={centroid[0]}
          y1={centroid[1]}
          x2={inflexionPoint[0]}
          y2={inflexionPoint[1]}
          stroke={"black"}
          fill={"black"}
        />
        <line
          x1={inflexionPoint[0]}
          y1={inflexionPoint[1]}
          x2={labelPosX}
          y2={inflexionPoint[1]}
          stroke={"black"}
          fill={"black"}
        />
        <text
          x={labelPosX + (isRightLabel ? 2 : -2)}
          y={inflexionPoint[1]}
          textAnchor={textAnchor}
          dominantBaseline="middle"
          fontSize={14}
        >
          {label}
        </text>
      </g>
    );
  });

  return (
    <svg width={width} height={height}
      style={{
        display: "inline-block",
        opacity: example ? 0.5 : 1,
      }}
    >
      <g
        transform={`translate(${width / 2}, ${height / 2})`}
        className={"container"}
        ref={ref}
      >
        {shapes}
      </g>
    </svg>
  );
};